import { instance } from './index';

//매체 목록 조회
function listMedia(queries) {
  return instance.get('api/medias', queries);
}

//매체·코스 등록/수정 권한 조회
function mediaPermission() {
  return instance.get('api/medias/permission');
}

//매체 생성
function createMedia(data) {
  return instance.post('api/medias', data);
}

//매체 상세
function detailMedia(id) {
  return instance.get(`api/medias/${id}`);
}
//매체 수정
function modifylMedia(id, data) {
  return instance.put(`api/medias/${id}`, data);
}

//매체 지면 목록 조회
function listMediaInventories(id) {
  return instance.get(`api/medias/${id}/inventories`);
}

//edit media info
function updateMedia(id, data) {
  return instance.put(`api/media/${id}`, data);
}

//get campaigns on media
function campaignOnMedia() {
  return instance.put('​​api​/media​/update​/v1');
}

export {
  listMedia,
  mediaPermission,
  createMedia,
  detailMedia,
  modifylMedia,
  listMediaInventories,
  updateMedia,
  campaignOnMedia,
};
